jQuery(document).ready(function($) {
  $('#input-form-same-billing').on('change', function() {
    if ( $(this).prop('checked') ) {
      $('.shipping-address input:not([type="checkbox"]), .shipping-address select').prop('disabled', true);
      $('.shipping-address input, .shipping-address select').removeClass('required');
    } else {
      $('.shipping-address input:not([type="checkbox"]), .shipping-address select').prop('disabled', false);
    }
  });

  $('#input-form-agreement').on('change', function() {
    if ( $(this).prop('checked') ) {
      $('.agreement-input').prop('disabled', false);
    } else {
      $('.agreement-input').prop('disabled', true);
    }
  });

  $('#account-address .next-step').on('click', function() {
    var requiredFields = $('#account-address input:not(:disabled):required');
    $("html, body").animate({ scrollTop: "0" }); 

    for ( var i = 0; i < requiredFields.length; i++ ) {
      if ( requiredFields.eq(i).val().length == 0 ) {
        requiredFields.eq(i).addClass('required');
      } else {
        requiredFields.eq(i).removeClass('required');
      }
    }

    if ( $('#account-address input.required').length == 0 ) {
      $('.stepbar .single-step').removeClass('active');
      $('.stepbar .single-step[data-index=1]').addClass('passed');
      $('.stepbar .single-step[data-index=2]').addClass('active');
      $('.account-info-form-wrapper .account-form-field').removeClass('active');
      $('#trade-program').addClass('active');
    }
  });

  $('#trade-program .back-step').on('click', function() {
    $('.stepbar .single-step').removeClass('active');
    $('.stepbar .single-step[data-index=1]').addClass('active');
    $('.account-info-form-wrapper .account-form-field').removeClass('active');
    $('#account-address').addClass('active');
  });

  $('#account-information .submit-form').on('click', function() {
    var fileUploads = $('#trade-program input[type="file"]');
    $("html, body").animate({ scrollTop: "0" }); 

    fileUploads.each(function() {
      if ( ! $(this).val() ) {
        $(this).next('label').addClass('required');
      } else {
        $(this).next('label').removeClass('required');
      }
    });
  });

  $('.agreement-datepicker').datepicker();
});